module.exports = __webpack_public_path__ + "img/tabs.0506977e.svg";